import styled from 'styled-components';
import { FlexColumn } from "../../../../utils/containers";

const CsiStyle = styled(FlexColumn)`
  .csiStyle__logo {
    margin-top: 24px;
  }
  
  .CsiStyle__text {
    max-width: 500px;
  }

  h2 {
    margin-bottom: 40px;
  }
`;

export default CsiStyle;
